import {useFilterMenu} from 'src/pages/ActivityLogPage/FilterMenu';

export const activityFilterDefaultLabel = 'All Activity';
export const activityFilterMenuIds = {
  all: 'allActivity',
  offboard: 'offBoard',
  onboard: 'onboard',
  mfaDisabled: 'mfaDisabled',
  privilegeChange: 'privilegeChange',
  userActivity: 'userActivity',
  federationStatusChange: 'federationStatusChange',
}

// The options of the "Drift type" dropdown filter
const activityFilterOptions = [
  {id: activityFilterMenuIds.all, value: '', label: activityFilterDefaultLabel},
  {id: activityFilterMenuIds.offboard, value: '', label: 'Offboard'},
  {id: activityFilterMenuIds.onboard, value: '', label: 'Onboard'},
  {id: activityFilterMenuIds.federationStatusChange, value: '', label: 'Federation Status Change'},
  {id: activityFilterMenuIds.mfaDisabled, value: '', label: 'MFA Change'},
  {id: activityFilterMenuIds.privilegeChange, value: '', label: 'Privilege Change'},
  {id: activityFilterMenuIds.userActivity, value: '', label: 'User Activity'},
];

export const useActivityFilterMenu = () => {

  const filterMenu = useFilterMenu({
    label: 'Activity',
    options: activityFilterOptions,
    ariaLabel: 'Filter for Activity',
    menuId: 'activityFilterMenuId',
  });

  return {
    FilterMenu: () => (
      <SaasFilterMenu
        filterMenu = {filterMenu}
      />
    ),
    selectionState: filterMenu.selectionState,
  };
}

const SaasFilterMenu = ({filterMenu}: {filterMenu: any}) => {
  const FilterMenuComponent = filterMenu.filterMenu;
  return <FilterMenuComponent />
};
